//TODO: разобраться с Sentry
// import '@/configs/sentry';
import '@/configs/serviceworker-registration.ts';

import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import { queryClient } from '@/shared/api/queryClient';
import { RootProvider } from '@/shared/uikit/providers/root-provider';

import { init } from '@/utils/init';

import { store } from './store';
import App from '@/app/app';

init();

createRoot(document.getElementById('root') as HTMLElement).render(
	<QueryClientProvider client={queryClient}>
		<Provider store={store}>
			<RootProvider>
				<App />
			</RootProvider>
		</Provider>
		<ReactQueryDevtools initialIsOpen={false} />
	</QueryClientProvider>,
);
